import { Component, Input } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Router } from '@angular/router';

@Component({
  selector: 'app-nav-bar-split-button',
  templateUrl: './nav-bar-split-button.component.html',
  styleUrls: ['./nav-bar-split-button.component.scss'],
})
export class NavBarSplitButtonComponent {
  @Input() label!: string;
  @Input() icon = '';
  @Input() defaultRouterLink!: string;
  @Input() model!: MenuItem[];

  constructor(private router: Router) {}

  navigateToRouterLink() {
    this.router.navigateByUrl(this.defaultRouterLink);
  }
}
